import React from 'react'
import { Icon, Button } from 'semantic-ui-react'

import db_lib from 'xAppLib/libs/db_lib';

import AddAttachments from 'xAppLib/KnowledgeBase/AddAttachments'



const _MODEL_NAME = 'kb_model';

const _USE_DATA = 'API'
const _API_NAME = 'kb'

// export const _TYPES = app.app_data.ws_conf.KB.items


const _LIST_FLDS_ADMIN = [
						{
							name: 'Num',
							jpath: 'kbnum',
						},
						{
							name: 'Enabled',
							jpath: 'active',
							template : ({value:enabled}) => <React.Fragment>
											<Icon name={enabled && 'check circle outline' || 'x'} color={enabled&&'green'||'red'} size='large'/>
										</React.Fragment>
						},
						{
							name: 'Type',
							jpath: 'type'
						},
						{
							name: 'Title',
							jpath: 'title'
						},
						{
							name: 'Parent',
							jpath: 'kb_par_id',
							template: ({ value: kb_par_id, row }) => {
								
								/*
								 * TODO: Add parent name lookup
								 */
								return kb_par_id;
							}
						},
						{
							name:'Attachments',
							jpath: 'attachments',
							template:({value:attachments, onToggleAttachment,row}) => <React.Fragment> 
											{attachments && attachments.length && <Button size="mini" icon="file" content={attachments.length}  onClick={_=>{
												onToggleAttachment && onToggleAttachment(row.kbid)
											}}  />}
										</React.Fragment>
						},
						{
							name: 'Expiry',
							jpath: 'expiry',
							type:'date'
						},
						{
							name: 'Order',
							jpath: 'rec_order',
						}
					];

					
// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

export default class kb_model extends db_lib {

	static get MODEL_NAME() { return _MODEL_NAME; }
	static get USE_DATA() { return _USE_DATA; }
	static get API_NAME() { return _API_NAME; }
	
	static get LIST_FLDS_ADMIN() { return _LIST_FLDS_ADMIN; }
	static get EDIT_FLDS_ADMIN() { return [
						{
							label: 'Enabled',
							name: 'active',
							type: 'bool',
							
						},
						{
							label:'Type',
							name: 'type',
							type:'text',
						},
						{
							label: 'Folder Name',
							name: 'title'
						},
						{
							label: 'Parent',
							name: 'kb_par_id',
							type: 'kb_parent',
							valid_not_required: true
						},
						{
							label: 'Attachments',
							name: 'attachments',
							type: AddAttachments,
							valid_not_required: true,
							params: {
								level: 'kb',
								accept: 'image/*, application/pdf, video/*',
								allowDirectLink: true,
								children: <p className={'mt-2 text-center'}>
									PDF, Image and Video files accepted.<br/>
									Files containing personal information should
									not be uploaded!
								</p>
							},
						},
						{
							label: 'Expiry',
							name: 'expiry',
							type: 'date',
							valid_not_required: true
						},
						{
							label: 'Order',
							name: 'rec_order',
							type: 'number',
							valid_not_required:true
						},
						
					]; }
	static get TYPES() { return app.app_data.ws_conf.KB.items; }
	

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static async get_kb_tree(type = null) {
		const res = await kb_model.get_record(null, null, {act: 'tree', type});
		return res.tree;
	}

	static api(endpoint, data) {
		return kb_model.get_record(null, null, {act:endpoint, ...data});
	}

	// CRUD
	static get(id) {
		return kb_model.api('get',{id})
	}
	
	static all(params) {
		return kb_model.api('all',params)
	}
	
	static update(id, data) {
		if (!data.kb_par_id) data.kb_par_id = null;
		return kb_model.api('update',{id, data})
	}
	
	static create(data) {
		return kb_model.api('create',{data})
	}
	
	static delete(id) {
		return kb_model.api('delete',{id})
	}

}
